import { render, staticRenderFns } from "./SectionBasic.vue?vue&type=template&id=302f5654&scoped=true&"
import script from "./SectionBasic.vue?vue&type=script&lang=ts&"
export * from "./SectionBasic.vue?vue&type=script&lang=ts&"
import style0 from "./SectionBasic.vue?vue&type=style&index=0&id=302f5654&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302f5654",
  null
  
)

export default component.exports